module.exports = __webpack_public_path__ + "static/media/down_arrow_green.43d0b9fb.svg";